import React from 'react';
import './MediaLibraryTabs.scss';

export type MediaLibraryTabType = 'base-images' | 'ai-images' | 'other-images';

interface MediaLibraryTabsProps {
  activeTab: MediaLibraryTabType;
  onTabChange: (tab: MediaLibraryTabType) => void;
  disabled?: boolean;
}

const tabs: { id: MediaLibraryTabType; label: string }[] = [
  { id: 'base-images', label: 'Base Images' },
  { id: 'ai-images', label: 'AI Images' },
  { id: 'other-images', label: 'Other Images' },
];

export const MediaLibraryTabs: React.FC<MediaLibraryTabsProps> = ({
  activeTab,
  onTabChange,
  disabled = false,
}) => {
  return (
    <div className="media-library-tabs">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          className={`media-library-tabs__tab ${activeTab === tab.id ? 'media-library-tabs__tab--active' : ''}`}
          onClick={() => onTabChange(tab.id)}
          disabled={disabled}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};
